"use client";

import { ChatNavigation } from "./chat-navigation";
import { ChatTitle } from "./chat-title";
import Image from "next/image";

export function ChatHeader() {
  return (
    <div className="flex items-center justify-center relative h-10">
      <ChatNavigation />
      <div className="flex items-center gap-2.5">
        <Image
          src="/brand/avatars/MindUP_Avatars_RGB_BrainAvatar.png"
          alt="MindUP"
          width={28}
          height={28}
          className="w-7 h-7 rounded-lg shadow-sm"
        />
        <ChatTitle />
      </div>
    </div>
  );
}
